import type { FC } from 'react';

import Dice1Icon from '../../assets/BLM/Dice1.svg';
import Dice2Icon from '../../assets/BLM/Dice2.svg';
import Dice3Icon from '../../assets/BLM/Dice3.svg';

import styles from './BLM.module.css';

const BLM_ICONS: Record<string, string> = {
  Dice1: Dice1Icon,
  Dice2: Dice2Icon,
  Dice3: Dice3Icon,
};

export const BLM: FC<{ diceValues: string[] }> = ({ diceValues = [] }) => {
  return (
    <div className={styles.blmContainer}>
      <div className={styles.blmDiceContainer}>
        {diceValues.map((number, index) => (
          <div className={styles.dice} key={index}>
            <img width="32" height="32" src={BLM_ICONS[`Dice${number}` as keyof typeof BLM_ICONS]} alt="" />
          </div>
        ))}
      </div>
    </div>
  );
};
